import React from 'react';
import CheckIcon from '@mui/icons-material/Check';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import PersonIcon from '@mui/icons-material/Person';
import GroupIcon from '@mui/icons-material/Group';
import PeopleIcon from '@mui/icons-material/People';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import { Link } from 'react-router-dom';

const offers = [
	{
		icon: <PersonIcon sx={{ fontSize: 32 }} />,
		title: 'Trening indywidualny',
		subtitle: 'Najbardziej dopasowana forma współpracy 1:1',
		pakiety: ['4 treningi (1× w tygodniu)', '8 treningów (2× w tygodniu)', '12 treningów (3× w tygodniu)'],
		cena: '120 zł / trening',
		items: [
			'indywidualny plan działania',
			'nauka poprawnej techniki',
			'dopasowanie ćwiczeń do poziomu',
			'stałe wsparcie i kontrola postępów',
		],
		accentFrom: '#A87B75',
		accentTo: '#956a64',
		bgClass: 'bg-primary-50',
		iconClass: 'bg-primary-100 text-primary-600',
		featured: true,
	},
	{
		icon: <GroupIcon sx={{ fontSize: 32 }} />,
		title: 'Trening w parze',
		subtitle: 'Trening dla dwóch osób o podobnym poziomie',
		pakiety: null,
		cena: '85 zł / osoba',
		items: [
			'wspólny trening dopasowany do poziomu',
			'nauka techniki i bezpiecznego ruchu',
			'motywacja i komfort wspólnego treningu',
		],
		accentFrom: '#a87050',
		accentTo: '#8c5d3f',
		bgClass: 'bg-[#faf6f2]',
		iconClass: 'bg-[#f3ebe1] text-[#8c5d3f]',
		featured: false,
	},
	{
		icon: <PeopleIcon sx={{ fontSize: 32 }} />,
		title: 'Mini grupa (3 osoby)',
		subtitle: 'Kameralne treningi w małej grupie',
		pakiety: null,
		cena: '65 zł / osoba',
		items: [
			'indywidualne wskazówki dla każdego',
			'korekta techniki',
			'motywująca, kameralna atmosfera',
		],
		accentFrom: '#A87B75',
		accentTo: '#a87050',
		bgClass: 'bg-primary-50',
		iconClass: 'bg-primary-100 text-primary-600',
		featured: false,
	},
	{
		icon: <TipsAndUpdatesIcon sx={{ fontSize: 32 }} />,
		title: 'Konsultacja treningowa',
		subtitle: 'Pierwszy krok przed rozpoczęciem współpracy',
		pakiety: null,
		cena: '120 zł',
		items: [
			'rozmowa i analiza potrzeb',
			'ocena poziomu i techniki',
			'wskazówki treningowe',
			'plan dalszego działania',
		],
		accentFrom: '#a87050',
		accentTo: '#744d33',
		bgClass: 'bg-[#faf6f2]',
		iconClass: 'bg-[#f3ebe1] text-[#8c5d3f]',
		featured: false,
	},
];

export default function OfferPage() {
	return (
		<div className="max-w-7xl mx-auto px-4 sm:px-6 pt-20 lg:pt-24 pb-16">
			<div className="text-center mb-14">
				<span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 rounded-full text-xs font-bold mb-5 tracking-widest uppercase font-montserrat-custom-medium">
					CENNIK
				</span>
				<h1 className="font-bold-custom text-4xl lg:text-5xl text-gray-900 mb-4">
					Oferta <span className="text-gradient">treningowa</span>
				</h1>
				<p className="text-gray-500 font-montserrat-custom-medium text-base max-w-lg mx-auto">
					Wybierz formę współpracy dopasowaną do Twoich potrzeb i celów.
				</p>
			</div>

			<div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
				{offers.map((offer, index) => (
					<div
						key={index}
						className={`relative rounded-3xl overflow-hidden shadow-soft hover:shadow-soft-lg transition-all duration-300 ${offer.featured ? 'ring-2 ring-primary-300' : ''}`}
					>
						{offer.featured && (
							<div className="absolute top-4 right-4 z-10 px-3 py-1 bg-primary-500 text-white text-xs font-bold rounded-full font-montserrat-custom-medium tracking-wide">
								NAJCHĘTNIEJ WYBIERANY
							</div>
						)}

						<div className={`${offer.bgClass} p-8 lg:p-10 h-full flex flex-col`}>
							<div className={`w-14 h-14 rounded-2xl flex items-center justify-center mb-5 ${offer.iconClass}`}>
								{offer.icon}
							</div>

							<h3 className="font-bold-custom text-2xl text-gray-900 mb-1">
								{offer.title}
							</h3>
							<p className="text-gray-500 font-montserrat-custom-medium text-sm mb-6">
								{offer.subtitle}
							</p>

							{offer.pakiety && (
								<div className="mb-6">
									<p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-3 font-montserrat-custom-medium">Pakiety</p>
									<div className="flex flex-wrap gap-2">
										{offer.pakiety.map((p, i) => (
											<span key={i} className="px-3 py-1.5 bg-white rounded-xl text-sm font-montserrat-custom-medium text-gray-700 shadow-soft border border-gray-100">
												{p}
											</span>
										))}
									</div>
								</div>
							)}

							<div className="mb-6">
								<p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-1 font-montserrat-custom-medium">Cena w pakiecie</p>
								<p className="font-bold-custom text-2xl text-gradient">{offer.cena}</p>
							</div>

							<div className="space-y-3 mb-8 flex-grow">
								{offer.items.map((item, i) => (
									<div key={i} className="flex items-start gap-3">
										<div className="w-5 h-5 rounded-full bg-white flex items-center justify-center flex-shrink-0 mt-0.5 shadow-soft">
											<CheckIcon sx={{ fontSize: 12 }} className="text-primary-600" />
										</div>
										<span className="text-gray-600 font-montserrat-custom-medium text-sm">{item}</span>
									</div>
								))}
							</div>

							<Link
								to="/contact"
								style={{ background: `linear-gradient(to right, ${offer.accentFrom}, ${offer.accentTo})` }}
								className="inline-flex items-center gap-2 px-6 py-3 text-white font-bold text-sm rounded-full shadow-soft hover:shadow-soft-lg hover:scale-105 transition-all duration-300 self-start"
							>
								ZAPISZ SIĘ
								<ArrowForwardIcon sx={{ fontSize: 16 }} />
							</Link>
						</div>
					</div>
				))}
			</div>
		</div>
	);
}
